import gql from 'graphql-tag';
import * as React from 'react';
import { Grid, ButtonBase, Card, Typography, createStyles, WithStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { QTaskCount, QTaskCountVariables } from '../gen/QTaskCount';
import { Query } from 'react-apollo';
import { CompanyStatus, PaperworkStatus, PaymentStatus } from '../gen/globalTypes';
import { Loading } from '../widgets/loading';

const styles = (theme: Theme) =>
    createStyles({
        cardAction: {
            display: 'block',
            textAlign: 'initial',
            width: '100%',
            padding: '12px',
            minWidth: '250px',
        }
    });

const TASK_COUNT_QUERY = gql`
query QTaskCount(
  $status: CompanyStatus
  $paperworkStatus: PaperworkStatus
  $paymentStatus: PaymentStatus
) {
  companies(
    status: $status
    paperworkStatus: $paperworkStatus
    paymentStatus: $paymentStatus
  ) {
    totalCount
  },
  allTasks(
    companyStatus: $status
    companyPaperworkStatus: $paperworkStatus
    companyPaymentStatus: $paymentStatus
  ) {
    totalCount
  }
}
`;

class TaskCountQuery extends Query<QTaskCount, QTaskCountVariables> { }

interface TaskCountProps extends WithStyles<typeof styles> {
    title?: string; // Optional, use only to load initial state in main companies page
    status?: CompanyStatus;
    paperworkStatus?: PaperworkStatus;
    paymentStatus?: PaymentStatus;
    selected?: boolean;
    onClick?: () => void;
}

class TaskCount extends React.Component<TaskCountProps & WithStyles<typeof styles>> {
    render = () => (
        <TaskCountQuery
            query={TASK_COUNT_QUERY}
            variables={{
                status: this.props.status,
                paperworkStatus: this.props.paperworkStatus,
                paymentStatus: this.props.paymentStatus,
            }}
        >
            {({ loading, error, data }) => {
                if (loading) {
                    return <Loading />;
                }
                if (error) {
                    return (
                        <pre style={{ whiteSpace: 'pre-line' }}>
                            {error.message}
                        </pre>
                    );
                }
                if (!data || !data.allTasks) {
                    // La comprobacion de !data.allTasks no debería ser necesaria 
                    // pero sin esto al hacer un resetStore hay un render con un data = {}
                    return <div />;
                }
                return (
                    <Card style={{ padding: 0 }} elevation={this.props.selected ? 8 : 1} >
                        <ButtonBase className={this.props.classes.cardAction} onClick={this.props.onClick}>
                            <Typography variant="h6">{this.props.title}</Typography>
                            <Grid container spacing={2}>
                                <Grid item md={6}>
                                    <Typography variant="overline" color="textSecondary">Empresas</Typography>
                                    <Typography variant="h6">{data.companies.totalCount || 0}</Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography variant="overline" color="textSecondary">Tareas</Typography>
                                    <Typography variant="h6">{data.allTasks.totalCount || 0}</Typography>
                                </Grid>
                            </Grid>
                        </ButtonBase>
                    </Card>
                );
            }}
        </TaskCountQuery>
    )
}

export default withStyles(styles)(TaskCount);